import {
  getAccessToken,
  refreshAccessToken,
  clearTokens,
  emitForcedLogout,
} from "./tokenService";

let isRefreshing = false;
let requestQueue = [];

const processQueue = (error, token = null) => {
  requestQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
      return;
    }
    resolve(token);
  });
  requestQueue = [];
};

export const attachInterceptors = (apiInstance) => {
  apiInstance.interceptors.request.use(
    (config) => {
      const token = getAccessToken();
      const url = config?.url || "";
      if (
        token &&
        !url.includes("/api/token/") &&
        !config.skipAuth
      ) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  apiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { response, config } = error || {};
      const status = response?.status;

      if (
        status === 401 &&
        config &&
        !config._retry &&
        !config.url.includes("/api/token/")
      ) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            requestQueue.push({
              resolve: (token) => {
                config.headers.Authorization = `Bearer ${token}`;
                config._retry = true;
                resolve(apiInstance(config));
              },
              reject,
            });
          });
        }

        config._retry = true;
        isRefreshing = true;

        try {
          const newToken = await refreshAccessToken();
          processQueue(null, newToken);
          config.headers.Authorization = `Bearer ${newToken}`;
          return apiInstance(config);
        } catch (refreshError) {
          processQueue(refreshError, null);
          clearTokens();
          emitForcedLogout();
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );
};

